export enum MODULES {
    PROJECT = 1,
    TEST = 2,
    CERTIFICATE = 3,
    MASTER = 4,
    USERMGMT = 5
}


export enum MODULESfilter {
    Project = 1,
    Test = 2,
    Certificate = 3,
}
export enum USERROLE {

}


export enum PROJECTSTATUS {
    PLANNED = 1,
    ENQUIRE = 2,
    INPROCESS = 3,
    CLOSED = 4,
    UNKNOWN = 5,
    REJECTED = 6
}


export enum PROJECTUSERROLE {

}